<template>
    <div id="app-quizz">
        <!-- DISPLAY QUIZZ -->
        <div v-if="!isDone">
            <!-- OPTIONAL FIELDS -->
            <div v-for="field in fields" :key="field.id"
                 class="form-group field">
                <label :for="'quizz-text-' + field.id"
                       class="field-label">{{ field.label }}</label>
                <input v-if="field.type==='text'"
                       type="text"
                       value=""
                       class="form-control"
                       :id="'quizz-text-' + field.id"
                       :name="'quizz-text-' + field.id"
                       :placeholder="field.placeholder ? field.placeholder : ''"
                       v-model="fieldModels[field.id]"
                       @input="updateModel(fieldModels, field.id, $event.target.value)"
                />
                <input v-else-if="field.type==='number'"
                       type="number"
                       value=""
                       :min="field.min" :max="field.max"
                       class="form-control"
                       :id="'quizz-text-' + field.id"
                       :name="'quizz-text-' + field.id"
                       v-model="fieldModels[field.id]"
                       @input="updateModel(fieldModels, field.id, $event.target.value)"
                />
            </div>

            <!-- QUESTIONS -->
            <question v-for="question in questions"
                      :key="question.id"
                      :question="question"
                      :cdn="cdn"
                      v-model="questionModels[question.id]"
                      @input="updateModel(questionModels, question.id, $event)"
            >
            </question>

            <!-- SUBSCRIPTION FORM -->
            <div class="form-group">
                <h3>{{ form.titre }}</h3>

                <!-- email -->
                <div v-if="isCheckEmail">
                    <label>{{ form.email }}</label>
                    <input class="form-control"
                           type="email"
                           placeholder="nom@example.com"
                           v-model="email"/>
                </div>

                <!-- opt-ins -->
                <div class="optins">
                    <div v-for="list in lists"
                         v-if="list.optin"
                         class="optin">
                        <input type="checkbox"
                               v-model="optinModels[list.id]"
                               :id="'optin-' + list.id"
                               class="optin-checkbox"
                        />
                        <label v-html="list.label"
                               :for="'optin-' + list.id"
                               class="optin-label"> </label>
                    </div>
                </div>

                <!-- submit -->
                <button v-if="!isLoading"
                        ref="submitButton"
                        :disabled="isDone"
                        class="btn btn-success"
                        @click="sendResults">
                    {{ form.bouton }}
                </button>
                <div v-else class="loader"></div>

                <div v-if="showError" id="error">{{ error }}</div>

                <div v-if="form['sous-bouton']"
                     v-html="form['sous-bouton']"
                     class="after-submit-button"
                ></div>
            </div>
        </div>

        <!-- DISPLAY GREETINGS -->
        <div v-else>
            <span v-if="greetings"
                  class="greetings"
                  v-html="greetings"></span>
            <br />
            <span v-if="formatResult"
                  class="resultat"
                  v-html="formatResult"></span>
        </div>
    </div>
</template>

<script>
    import Question from './Question.vue';

    export default {
        // DYNAMIC PROPERTIES
        data() {
            return {
                // config
                subscribeUrl: '/wp-content/plugins/quizz-plugin/subscribe.php',
                cdn: globalQuizzConfig['cdn'],
                lists: globalQuizzConfig['listes'],
                partners: globalQuizzConfig['partenaires'],
                fields: globalQuizzConfig['champs'],
                questions: globalQuizzConfig['questions'],
                form: globalQuizzConfig['formulaire'],
                redirectionUrl: globalQuizzConfig['redirection-url'],
                computeScore: globalQuizzConfig['calcul-score'],
                computeResult: globalQuizzConfig['calcul-resultat'],
                formatDisplay: globalQuizzConfig['formatte-affichage'],
                greetings: globalQuizzConfig['remerciement'],

                // state
                isLoading: false,
                isDone: false,
                fieldModels: {},
                questionModels: {},
                pointMap: {},
                optinModels: {},
                email: '',
                error: '',
                showError: false
            }
        },
        computed: {
            // query params
            partner() {
                const params = this.getQueryParams();
                return params && params['partenaire']
                    ? params['partenaire']
                    : 'default_partner';
            },

            // Form validation
            isFormValid() {
                let key;

                for (key in this.fieldModels) {
                    if (this.fieldModels.hasOwnProperty(key) && this.fieldModels[key].trim() === '') {
                        this.error = "Merci de remplir tous les champs";
                        return false;
                    }
                }
                for (key in this.questionModels) {
                    if (this.questionModels.hasOwnProperty(key) && this.questionModels[key] === '') {
                        this.error = "Merci de compléter toutes les questions";
                        return false;
                    }
                }
                for (key in this.optinModels) {
                    if (this.optinModels.hasOwnProperty(key) && this.optinModels[key] === false) {
                        this.error = "Merci de cocher toutes les cases";
                        return false;
                    }
                }
                let res = this.isEmailValid;

                if (res) {
                    this.error = "";
                }
                return res;
            },
            isCheckEmail() {
                return this.form['activer-email'] !== false;
            },
            isEmailValid() {
                if (this.isCheckEmail) {
                    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    let result = this.email.match(re);

                    if (!result) {
                        this.error = "Merci de saisir une adresse email valide";
                    }
                    return result;
                }
                return true;
            },

            // result
            score() {
                let points = 0;

                for (let key in this.questionModels) {
                    if (key && this.questionModels.hasOwnProperty(key) && typeof this.questionModels[key] !== 'undefined') {
                        points += parseInt(this.pointMap[this.questionModels[key]]);
                    }
                }
                return this.computeScore({points: points, fields: this.fieldModels});
            },
            result() {
                return this.computeResult({score: this.score, fields: this.fieldModels});
            },
            formatResult() {
                return this.formatDisplay({score: this.score, result: this.result});
            }
        },

        // METHODS
        methods: {
            getQueryParams() {
                let queryString = document.location.search;

                if (!queryString) {
                    return [];
                }
                queryString = queryString.substr(queryString.indexOf('?') + 1);

                let queryPairs = queryString.split('&');
                let params = {}, pair;

                for (let i = 0; i < queryPairs.length; i++) {
                    pair = queryPairs[i].split('=');
                    params[pair[0]] = pair[1];
                }
                return params;
            },
            updateModel(models, id, value) {
                this.$set(models, id, value);
            },
            sendResults() {
                if (!this.isFormValid) {
                    this.$console.log('debug', 'form is not valid');
                    this.showError = true;
                    return;
                }
                this.subscribeToLists();
            },
            subscribeToLists() {
                this.isLoading = true;

                let redirectUrl = '',
                    promises = [],
                    list = {},
                    code = '';

                this.lists.forEach(list => {
                    code = list['depend-du-resultat']
                        ? list.partenaires[this.partner][this.result]
                        : list.partenaires[this.partner];

                    if (list.redirect && list.url) {
                        if (list.iris) {
                            redirectUrl = list.url
                                + '?MultivariateId=' + code
                                + '&oneClick=true'
                                + '&email=' + this.email
                                + '&partner=' + this.partner;
                        } else {
                            redirectUrl = list.url
                                + '?sourcecode=' + code
                                + '&email=' + this.email;
                        }
                        return;
                    }
                    promises.push(this.subscribeToList(code, list.url));
                });
                Promise.all(promises).then(value => {
                    if (this.redirectionUrl.confirmation) {
                        let d = new Date();
                        d.setTime(d.getTime() + (60 * 60 * 1000)); // 1h expiration

                        let value = "quizz-score" + "=" + this.score + ";";
                        let expires = "expires=" + d.toUTCString() + ";";
                        let path = "path=/;";
                        document.cookie = value + expires + path;

                        value = "quizz-result" + "=" + this.result + ";";
                        expires = "expires=" + d.toUTCString() + ";";
                        path = "path=/;";
                        document.cookie = value + expires + path;

                        value = "quizz-formatted-result" + "=" + encodeURIComponent(this.formatResult) + ";";
                        expires = "expires=" + d.toUTCString() + ";";
                        path = "path=/;";
                        document.cookie = value + expires + path;

                        const location  = window.location;

                        let protocol = location.protocol;
                        let slashes = protocol.concat("//");
                        let host = slashes.concat(location.hostname);

                        let nextUrl = this.redirectionUrl.confirmation;

                        if (this.redirectionUrl.genererId) {
                            let id = this.generateFsid();
                            nextUrl += '?Fsid=' + id;
                        }
                        this.$console.log('debug', 'redirecting to confirmation page');

                        this.redirect(host + '/' + nextUrl);

                        return;
                    }

                    this.isLoading = false;

                    if (redirectUrl) {
                        this.redirect(redirectUrl);
                    } else {
                        this.isDone = true;
                    }
                }).catch(error => {
                    this.$console.log('warn', error);
                });
            },
            subscribeToList(code, url) {
                return new Promise((resolve, reject) => {
                    // 30s timeout
                    const timeout = setTimeout(() => {
                        reject();
                    }, 30000);

                    const req = new XMLHttpRequest();
                    req.onreadystatechange = (e) => {
                        if (req.readyState === XMLHttpRequest.DONE) {
                            clearTimeout(timeout);
                            if (req.status === 200) {
                                resolve();
                            } else {
                                reject();
                            }
                        }
                    };
                    req.open('POST', this.subscribeUrl);
                    req.setRequestHeader("Content-Type", "application/json");
                    const data = {
                        baseUrl: url,
                        email: this.email,
                        sourcecode: code,
                        partner: this.partner
                    };
                    req.send(JSON.stringify(data));
                });
            },
            redirect(url) {
                document.location.replace(url);
            },

            /**
             * Generate FSID for confirmation page
             *
             * @returns {string} a random ID made of 5 hex numbers of 8 digits separed by an hyphen
             */
            generateFsid() {
                let res = '';

                for (let i = 0; i < 5; i++) {
                    if (i > 0) {
                        res += '-';
                    }
                    res += parseInt(Math.random() * Math.pow(10, 9)).toString(16);
                }
                return res;
            }
        },

        // LIFECYCLE
        mounted() {
            this.$console.log('debug', 'Quizz::mounted');

            // Models initialization - /!\ Used when validating form
            //
            // initialize models for additional text fields
            this.fields.forEach(field => {
                this.$set(this.fieldModels, field.id, '');
            });

            // initialize models for questions
            // initialize points map
            this.questions.forEach(question => {
                this.$set(this.questionModels, question.id, '');

                question.reponses.forEach(reponse => {
                    this.pointMap[question.id + '-' + reponse.id] = reponse.points;
                });
            });

            // initialize opt-ins
            this.lists.forEach(list => {
                if (list.optin) {
                    this.$set(this.optinModels, list.id, false);
                }
            });
        },

        // COMPONENTS
        components: {
            question: Question
        }

    };
</script>


// WEBPACK FOOTER //
// Quizz.vue?3d867975